module.exports = __webpack_public_path__ + "images/ssangyong_small669ff237db21c5e53e815a039b1167e8.png";